export const enum MINE_GAME_ACTION {
  DIG = "digging",
  REP = "repairing",
  HEALTH = "mine:get-health"
}

export const enum MINE_SOCKETS {
  DATA = "mine:get-health",
  REWARD = "mine:get-reward"
}

export enum MineConditions {
  Green = "green",
  Yellow = "yellow",
  Red = "red"
}
